// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1meGK","modal":"Modal_modal__1JCzf","slide-down":"Modal_slide-down__ezgTS"};